// extracted by mini-css-extract-plugin
module.exports = {"SIconRow":"IconRow_SIconRow__QB_pv","SIconLink":"IconRow_SIconLink__5c_QP","SIconText":"IconRow_SIconText__YdIff"};